import { LottieRefCurrentProps } from 'lottie-react';

import { ServicesLobbyCardDto } from '@/components/ServicesLobbyPage/ServicesLobbyCards/types';

export const getEndFrame = (
	instance: LottieRefCurrentProps,
	animationData: ServicesLobbyCardDto['lottie']
) => {
	const duration = instance.getDuration(true);

	if (duration !== undefined && duration > 0) return Math.max(0, Math.floor(duration - 1));

	const { op = 0, ip = 0 } = animationData as { op?: number; ip?: number };

	return Math.max(0, Math.floor(op - ip - 1));
};
